/**
 * Widget-local hook: reproduces the legacy auto-open behavior for the stats widget.
 *
 * Guardrail: keep behavior identical.
 * - When loading/results appear, open the stats widget.
 * - On mobile, close mapFilter before opening stats.
 */

import { useEffect, useState } from "react";

import { BBStore } from "SandboxViewerComponent/src/stores/UiStore";

const useAutoOpenStatsWidget = ({
  CommunicationStore,
  resultTableLoading,
  tableResult,
}) => {
  const [initiated, setInitiated] = useState(false);

  useEffect(() => {
    if (resultTableLoading || tableResult) {
      if (!initiated) {
        if (BBStore.mobile) CommunicationStore.closeWidget("mapFilter");
        CommunicationStore.openWidget("stats");
        setInitiated(true);
      }
    }
  }, [resultTableLoading, tableResult, initiated, CommunicationStore]);

  return { initiated };
};

export default useAutoOpenStatsWidget;
